import { createContext } from 'react';
import MUIPopper from '@material-ui/core/Popper';
export var Context = /*#__PURE__*/createContext({
  Popper: MUIPopper
});
var Provider = Context.Provider,
    Consumer = Context.Consumer;
export { Provider, Consumer };